// extracted by mini-css-extract-plugin
module.exports = {"input-number":"style_input-number__k6G2C"};